import { Alert, AlertDescription, Button } from '@up2stay/up2promo-ui';
import { Phone } from 'lucide-react';

import { useNavigateShell } from '@/core/hooks/use-navigate-shell';
import { shellPaths } from '@/core/router/app-paths';

type SmsPhoneSettingsBannerProps = {
  title: string;
  description: string;
  actionLabel: string;
};

export function SmsPhoneSettingsBanner({
  title,
  description,
  actionLabel,
}: SmsPhoneSettingsBannerProps) {
  const { navigateShell } = useNavigateShell();

  return (
    <Alert className="border-primary/30 bg-primary/5">
      <Phone className="h-4 w-4" />
      <AlertDescription className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
          <p className="font-medium text-foreground">{title}</p>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={() => navigateShell(shellPaths.moreUserSettingsPhone)}
        >
          {actionLabel}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
